import { render, staticRenderFns } from "./position-list.vue?vue&type=template&id=211454d2&scoped=true&"
import script from "./position-list.vue?vue&type=script&lang=js&"
export * from "./position-list.vue?vue&type=script&lang=js&"
import style0 from "./position-list.vue?vue&type=style&index=0&id=211454d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211454d2",
  null
  
)

export default component.exports